import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { sizeAlertCreator } from 'shared/lib/sizeAlertCreator'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useMessageFieldContext } from 'widgets/MessageField/context/MessageFieldContext'
import { airCallTooltip } from 'widgets/constants'

export const Alerts = observer(() => {
  const messageFieldStore = useMessageFieldContext()
  const entities = useEntitiesContext()
  const {
    sendAlert,
    extError,
    limitSizeErrors,
    isAirCallNoSupportMms,
    isAttachmentsCountLimitError,
    textLimitReached,
    textLimit,
    isShowCustomShortUrlBanner,
    isUnicodeMessage,
    deleteLimitSizeError,
    handleCloseCustomShortUrlBanner,
  } = messageFieldStore

  const user = entities.usersStore.user

  const handleToCustomShortUrl = () => {
    uiStore.changeRoute({
      path: '/settings/organization/custom-url-shortener',
      type: 'vue',
    })
  }

  return (
    <>
      {isShowCustomShortUrlBanner &&
        !(user?.isViewOnlyRole || user?.isMemberRole || user?.isManagerRole) && (
          <Alert
            item={{
              desc: 'NEW! Customize short URLs with your own domain name.',
              type: 'infoBlue',
            }}
            actions={[
              {
                variant: 'button',
                type: 'primary',
                text: 'Try it now',
                onClick: handleToCustomShortUrl,
              },
            ]}
            onClose={handleCloseCustomShortUrlBanner}
          />
        )}
      {isUnicodeMessage && (
        <Alert
          item={{
            desc: 'Your message contains unknown characters and may require additional credits to be sent',
            type: 'warning',
          }}
        />
      )}
      {textLimit.showAlert && textLimitReached && (
        <Alert
          item={{
            desc: textLimit.message,
            type: 'error',
          }}
        />
      )}
      {isAttachmentsCountLimitError && (
        <Alert
          item={{
            desc: 'You can send up to 5 attachments in one MMS',
            type: 'error',
          }}
        />
      )}
      {Boolean(limitSizeErrors.length) &&
        limitSizeErrors.map(({ label, limit }) => {
          const alertData = sizeAlertCreator({ label, limit })

          return (
            <Alert
              key={label}
              item={{
                desc: `${alertData.title}. ${alertData.desc}`,
                type: 'error',
              }}
              onClose={() => {
                deleteLimitSizeError(label)
              }}
            />
          )
        })}
      {extError && (
        <Alert
          item={{
            desc: extError,
            type: 'error',
          }}
          onClose={messageFieldStore.clearExtError}
        />
      )}
      {sendAlert && (
        <Alert
          item={{
            desc: sendAlert,
            type: 'error',
          }}
        />
      )}
      {isAirCallNoSupportMms && !entities.featureFlagsStore.aircall_new_api && (
        <Alert
          item={{
            desc: airCallTooltip,
            type: 'error',
          }}
        />
      )}
    </>
  )
})
